// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"212":"f2db517e","592":"3b7a46b8","892":"918ae46f","952":"90ed927f"}[chunkId] + ".chunk.js";
};